import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableRow } from '@digdir/designsystemet-react';

import { Energiforbruk } from '../../../../../types/building';
import {
  AccentedTableRow,
  LeftBorderCell,
  StyledTable
} from '../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface EnergibehovLokaltklimaProps {
  totalOppvarmetBRA: number | undefined;
  energiforbrukILokaltKlima: Energiforbruk;
}

export const LokaltklimaView: FC<EnergibehovLokaltklimaProps> = ({ totalOppvarmetBRA, energiforbrukILokaltKlima }) => {
  const { t } = useTranslation();

  const filteredEnergiBehovLokaltKlima = !energiforbrukILokaltKlima
    ? null
    : {
        romoppvarming: energiforbrukILokaltKlima.romoppvarming,
        varmtvann: energiforbrukILokaltKlima.varmtvann,
        vifter: energiforbrukILokaltKlima.vifter,
        pumper: energiforbrukILokaltKlima.pumper,
        belysning: energiforbrukILokaltKlima.belysning,
        tekniskutstyr: energiforbrukILokaltKlima.teknisk_utstyr,
        total: energiforbrukILokaltKlima.totalt_netto_energibehov
      };

  const filteredLevertEnergiLokaltKlima = !energiforbrukILokaltKlima
    ? null
    : {
        elektrisitet: energiforbrukILokaltKlima.elektrisitet,
        olje: energiforbrukILokaltKlima.olje,
        gass: energiforbrukILokaltKlima.gass,
        biobrensel: energiforbrukILokaltKlima.biobrensel,
        fjernvarme: energiforbrukILokaltKlima.fjernvarme,
        annenEnergivare: energiforbrukILokaltKlima.annen_energivare,
        total: energiforbrukILokaltKlima.totalt_levert_energi
      };

  return (
    <Fragment>
      {filteredEnergiBehovLokaltKlima && (
        <StyledTable>
          <TableBody>
            <AccentedTableRow $isSecondarySection>
              <TableCell colSpan={3}>{t('register.summary.header.nettoEnergibehovLokaltKlima')}</TableCell>
            </AccentedTableRow>
            <AccentedTableRow $isSecondarySection>
              <TableCell>{t('register.summary.result.energivare')}</TableCell>
              <LeftBorderCell>{t('register.summary.header.nettoEnergibehovPerYear')}</LeftBorderCell>
              <LeftBorderCell>{t('register.summary.header.spesifiktEnergibehov')}</LeftBorderCell>
            </AccentedTableRow>
            <AccentedTableRow>
              <TableCell />
              <LeftBorderCell>{t('expertToolsJSON.summary.suffix.kWh')}</LeftBorderCell>
              <LeftBorderCell>{t('expertToolsJSON.summary.suffix.kWhM2')}</LeftBorderCell>
            </AccentedTableRow>
            {Object.entries(filteredEnergiBehovLokaltKlima).map(([key, value]) => {
              const isTotalRow = key === 'total';
              return isTotalRow ? (
                <AccentedTableRow key={key}>
                  <TableCell>{t(`register.summary.result.${key}`)}</TableCell>
                  <LeftBorderCell>{value.toFixed(1)}</LeftBorderCell>
                  <LeftBorderCell>{totalOppvarmetBRA ? (value / totalOppvarmetBRA).toFixed(2) : '0.00'}</LeftBorderCell>
                </AccentedTableRow>
              ) : (
                value > 0 && (
                  <TableRow key={key}>
                    <TableCell>{t(`register.summary.result.${key}`)}</TableCell>
                    <LeftBorderCell>{value.toFixed(1)}</LeftBorderCell>
                    <LeftBorderCell>
                      {totalOppvarmetBRA ? (value / totalOppvarmetBRA).toFixed(2) : '0.00'}
                    </LeftBorderCell>
                  </TableRow>
                )
              );
            })}
          </TableBody>
        </StyledTable>
      )}

      {filteredLevertEnergiLokaltKlima && (
        <StyledTable>
          <TableBody>
            <AccentedTableRow $isSecondarySection>
              <TableCell colSpan={3}>{t('register.summary.header.levertEnergiLokaltKlima')}</TableCell>
            </AccentedTableRow>
            <AccentedTableRow $isSecondarySection>
              <TableCell>{t('register.summary.result.energivare')}</TableCell>
              <LeftBorderCell>{t('register.summary.header.levertEnergiPerYear')}</LeftBorderCell>
              <LeftBorderCell>{t('register.summary.header.spesifiktLevertEnergi')}</LeftBorderCell>
            </AccentedTableRow>
            <AccentedTableRow>
              <TableCell />
              <LeftBorderCell>{t('expertToolsJSON.summary.suffix.kWh')}</LeftBorderCell>
              <LeftBorderCell>{t('expertToolsJSON.summary.suffix.kWhM2')}</LeftBorderCell>
            </AccentedTableRow>
            {Object.entries(filteredLevertEnergiLokaltKlima).map(([key, value]) => {
              const isTotalRow = key === 'total';
              return isTotalRow ? (
                <AccentedTableRow key={key}>
                  <TableCell>{t(`register.summary.result.${key}`)}</TableCell>
                  <LeftBorderCell>{value.toFixed(1)}</LeftBorderCell>
                  <LeftBorderCell>{totalOppvarmetBRA ? (value / totalOppvarmetBRA).toFixed(2) : '0.00'}</LeftBorderCell>
                </AccentedTableRow>
              ) : (
                value > 0 && (
                  <TableRow key={key}>
                    <TableCell>{t(`register.summary.result.${key}`)}</TableCell>
                    <LeftBorderCell>{value.toFixed(1)}</LeftBorderCell>
                    <LeftBorderCell>
                      {totalOppvarmetBRA ? (value / totalOppvarmetBRA).toFixed(2) : '0.00'}
                    </LeftBorderCell>
                  </TableRow>
                )
              );
            })}
          </TableBody>
        </StyledTable>
      )}
    </Fragment>
  );
};
